module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.gallery != null && _vm.gallery.photos != undefined) ? _c('section', {
    attrs: {
      "id": "places"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main_title mt_wave a_center"
  }, [_c('h2', {
    directives: [{
      name: "lang",
      rawName: "v-lang.gallery",
      modifiers: {
        "gallery": true
      }
    }],
    staticClass: "uppercase"
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "main_description a_center"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.gallery.photos), function(photo) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-3"
    }, [_c('item-place', {
      attrs: {
        "src": photo.large,
        "title": ""
      }
    })], 1)
  }))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-452fcb9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/places/Places.vue
// module id = 364
// module chunks = 0